export default Object.freeze({
    CONTAINER_ID: process.env.VUE_APP_GTM_CONTAINER_ID,
});
